import { render, staticRenderFns } from "./FilterChipTemplate.vue?vue&type=template&id=a69b770c&scoped=true"
import script from "./FilterChipTemplate.vue?vue&type=script&lang=ts"
export * from "./FilterChipTemplate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a69b770c",
  null
  
)

export default component.exports